export default function opinionsSlider() {
  const opinionsSlider = new Swiper(".js-opinions-slider", {
    slidesPerView: 1,
    loop: false,
    centered: false,
    spaceBetween: 0,
    speed: 500,
    navigation: {
      nextEl: ".opinions-slider .swiper-button-next",
      prevEl: ".opinions-slider .swiper-button-prev",
    },
  });
}

document.addEventListener("DOMContentLoaded", () => {
  opinionsSlider();
});
